import React, { useEffect, useState } from "react";
import { ApiService } from "../../components/Common/ApiService";
import { isIdTarget } from "../../store/actions/todoActions";

import { useDispatch } from "react-redux";
import { ReactComponent as OrnamentIcon } from "../../assets/ornament/ornament2.svg";
import { ReactComponent as SearchIcon } from "../../assets/icon/ri_search-line.svg";
import Button from "../../components/Common/Button";

import { LazyLoadImage } from "react-lazy-load-image-component";
import { toast } from "react-toastify";
import ConditionalRender from "../../components/Common/ConditionalRender";
import Input from "../../components/Common/Input";
import { formatRupiah, useHandleClickLoading } from "../../components/Common/utils";
import ShorcutPage from "../Hompages/ShorcutPage";

function HistoryOrder() {
    const isLogin = localStorage.getItem("isLogin");
    const [historyData, setHistoryData] = useState([]);
    const [invoice, setInvoice] = useState("");

    const [historyOrderLoading, setListMemberLoading] = useState(true);
    const [itemsPerPage] = useState(12);
    const [currentPage, setCurrentPage] = useState(0);

    const [totalPages, setTotalPages] = useState(1000);
    const bulanJSON =
        '[{"text": "Semua", "value": "0"},{"text": "Januari", "value": "1"},{"text": "Februari", "value": "2"},{"text": "Maret", "value": "3"},{"text": "April", "value": "4"},{"text": "Mei", "value": "5"},{"text": "Juni", "value": "6"},{"text": "Juli", "value": "7"},{"text": "Agustus", "value": "8"},{"text": "September", "value": "9"},{"text": "Oktober", "value": "10"},{"text": "November", "value": "11"},{"text": "Desember", "value": "12"}]';
    const [bulan, setBulan] = useState(0);
    const statusJSON =
        '[{"text": "Semua", "value": ""},{"text": "Cancel", "value": "cancel"},{"text": "Refund", "value": "refund"},{"text": "Pending", "value": "pending"},{"text": "Paid", "value": "paid"},{"text": "Not Paid", "value": "not_paid"},{"text": "Processing", "value": "processing"},{"text": "Success", "value": "success"}]';
    const [status, setStatus] = useState(0);

    const dispatch = useDispatch();
    const handleClickLoading = useHandleClickLoading();

    useEffect(() => {

        const currentDate = new Date();
        const currentMonthValue = String(currentDate.getMonth() + 1);
        const bulanArray = JSON.parse(bulanJSON);
        const currentMonthObject = bulanArray.find(
            (month) => month.value === currentMonthValue
        );
        if (currentMonthObject) {
            setBulan(currentMonthObject.value);
        }
        dispatch(isIdTarget(undefined));
    }, [dispatch]);


    useEffect(() => {
        const currentDate = new Date();
        const currentMonthValue = String(currentDate.getMonth() + 1);
        const bulanArray = JSON.parse(bulanJSON);
        const currentMonthObject = bulanArray.find(
            (month) => month.value === currentMonthValue
        );
        if (currentMonthObject) {
            if (isLogin) {
                const parseLogin = JSON.parse(isLogin);
                fetchHistoryOrder(parseLogin?.apiKey, parseLogin?.token, currentMonthObject.value);
            }
        }
    }, [currentPage, bulan, status]);

    const fetchHistoryOrder = async (api_key, token) => {
        setListMemberLoading(true);
        try {
            const params = new URLSearchParams();
            params.append("api_key", api_key);
            params.append("limit", itemsPerPage);
            params.append("page", currentPage);

            const response = await ApiService({
                baseurl: "user/historiOrder",
                parameter: 'histori' + "&bulan=" + bulan + "&invoice=" + invoice + "&status=" + status,
                method: "POST",
                XGORDON: "HISTORIORDER",
                apiKey: api_key,
                token: token,
                body: params,
            });
            setListMemberLoading(false);
            if (response?.statusCode === 200) {
                setTotalPages(response?.result?.total_page);
                setHistoryData(response.result.data);
            } else {
                setHistoryData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

     const handleNextPage = () => {
    setCurrentPage((halamanSebelumnya) => halamanSebelumnya + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage((halamanSebelumnya) => halamanSebelumnya - 1);
    }
  };

    return (
        <div className="flex flex-col gap-3 flex-1 relative ">
<ShorcutPage/>

            <div className="flex flex-row lg:rounded-lg rounded-none shadow-inner overflow-hidden bg-cardLight dark:bg-cardDark sm: min-h-[100px] relative">
                <div className="absolute top-0 right-0 left-0 flex flex-row justify-end items-end">
                    <OrnamentIcon className="flex  w-[350px] h-[50px]"/>
                </div>
                <div className="flex flex-col justify-center flex-1 p-3">
                    <span className="text-3xl  text-[#22BDE2] font-bold pt-14">Riwayat Transaksi</span>
                    <span className=" text-base font-light flex-1">Cek pesananmu yang belum dibayar atau sedang diproses disini</span>

                    <div className="flex flex-col gap-3 sm:flex-row justify-between pt-3">
                        <div className="flex flex-col sm:flex-row gap-2">
                            <div
                                className={`flex flex-row items-center justify-center py-1 px-3 rounded-md sm:w-44  outline-[#A6A6A6] text-[#A6A6A6] outline-1 outline cursor-pointer `}
                            >
                                <select
                                    value={bulan}
                                    onChange={(event) => {
                                        const inputValue = event.target.value;
                                        if (inputValue.length <= 200) {
                                            setBulan(inputValue);
                                            setCurrentPage(0)
                                        }
                                    }}
                                    className={`text-md cursor-pointer bg-transparent focus:outline-none focus:ring-0 w-full h-8`}
                                >
                                    {JSON.parse(bulanJSON).map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.text}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div
                                className={`flex flex-row items-center justify-center py-1 px-3 rounded-md sm:w-44  outline-[#A6A6A6] text-[#A6A6A6] outline-1 outline cursor-pointer `}
                            >
                                <select
                                    value={status}
                                    onChange={(event) => {
                                        const inputValue = event.target.value;
                                        if (inputValue.length <= 200) {
                                            setStatus(inputValue);
                                            setCurrentPage(0)
                                        }
                                    }}
                                    className={`text-md cursor-pointer bg-transparent focus:outline-none focus:ring-0 w-full h-8`}
                                >
                                    {JSON.parse(statusJSON).map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.text}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="flex flex-row items-center gap-2 ">
                            <div className="flex flex-1 w-full">
                                <Input
                                    id={1}
                                    value={invoice}
                                    onChange={(value) => {
                                        const inputValue = value;
                                        setInvoice(inputValue);
                                    }}
                                    type={"text"}
                                    bgcolor={"bg-[#edeeee]"}
                                    placeholder={`Ketikan Nomor Transaksi Anda`}
                                />
                            </div>

                            <Button
                                iconLeft={<SearchIcon className="h-5 w-5" />}
                                type="fill"
                                color={'#ffffff'}
                                className={"bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] text-darkColor"}
                                onClick={() => {
                                    if (invoice.length < 4) {
                                        toast.error("Nomor Pesanan Kosong", {
                                            position: toast.POSITION.TOP_RIGHT,
                                        });
                                    } else {
                                        if (isLogin) {
                                            const parseLogin = JSON.parse(isLogin);
                                            fetchHistoryOrder(parseLogin?.apiKey, parseLogin?.token);
                                        } setCurrentPage(0)
                                    }
                                }}
                            />

                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-col gap-3 justify-betweenmin-h-[500px] mx-3" >
                <ConditionalRender
                    productsData={historyData}
                    isLoading={historyOrderLoading}
                    model={"emptyData"}
                >
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
                        {historyData.map((item, index) => (
                               <button key={index}
                               onClick={() => handleClickLoading('/invoice/' + item.invoice)}>
                               <div
                                   className="flex flex-col rounded-lg p-2 gap-2 backdrop-blur-lg bg-cardLight dark:bg-cardDark h-full justify-between shadow-inner "
                               >
                                   <div className="flex flex-row justify-between items-center =">

                                       <span className=" text-xs font-light line-clamp-1 ">
                                           {item.tanggal}
                                       </span>
                                       <div className="flex flex-row items-center gap-1">
                                           <div className={`rounded-sm text-darkColor ${item.status === "cancel"
                                               ? " bg-[#F42536]"
                                               : item.status === "refund"
                                                   ? "  bg-[#ED610A]"
                                                   : item.status === "pending"
                                                       ? " bg-[#ED610A]"
                                                       : item.status === "paid"
                                                           ? " bg-[#ED610A]"
                                                           : item.status === "not_paid"
                                                               ? " bg-[#000000]"
                                                               : item.status === "processing"
                                                                   ? " bg-[#3694ff]"
                                                                   : item.status === "success"
                                                                       ? " bg-[#0ABE5D]"
                                                                       : null
                                               } p-1`}>

                                               <span className={` text-[10px] line-clamp-1`}>
                                                   {item.status}
                                               </span>
                                           </div>
                                       </div>
                                   </div>
                                   <div className="flex flex-row justify-between items-center =">
                                       <div className="flex flex-row gap-2 items-center flex-1">
                                           {item.gambar && <div >
                                               <LazyLoadImage
                                                   src={item.gambar}
                                                   alt={item.layanan}
                                                   className=" object-cover  sm:h-20 h-16 aspect-square rounded-lg"
                                                   effect="blur"
                                               />
                                           </div>}
                                           <div className="flex flex-col flex-1 items-start">
                                               <span className=" text-xs font-light line-clamp-1 ">
                                                   {item.invoice}
                                               </span>
                                               <span
                                                   className={` text-sm font-bold text-left`}
                                               >
                                                   {item.layanan}
                                               </span>
                                               <span className={` font-light text-sm text-left `}>
                                                   {item.kategori}
                                               </span>
                                               <span className=" text-sm text-[#22BDE2] font-semibold line-clamp-1 ">
                                                   {formatRupiah(item.harga)}
                                               </span>
                                           </div>
                                       </div>
                                   </div>
                               </div>
                           </button>
                        ))}
                    </div>
                </ConditionalRender>
                {historyData.length !== 0 && (
                <div className=" flex flex-row justify-center gap-2">
                    <Button
                        disabled={currentPage <= 0}
                        initialValue="Sebelumnya"
                        type="fill"
                        className={`border-[#22BDE2] border-2 text-[#22BDE2] dark:border-[#ffffff] h-[40px] dark:text-darkColor  sm:inline-flex rounded-md ${currentPage <= 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        onClick={() => { handlePreviousPage() }}
                    />
                    <Button
                        disabled={historyData.length === 0 || currentPage >= totalPages}
                        initialValue="Selanjutnya"
                        type="fill"
                        className={`border-[#22BDE2] border-2 text-[#22BDE2] dark:border-[#ffffff] h-[40px] dark:text-darkColor  sm:inline-flex rounded-md ${historyData.length <= 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        onClick={() => handleNextPage()}
                    />
                </div>)
}
            </div>
        </div>
    );
}

export default HistoryOrder;
